import React from 'react';
import axios from 'axios';
import { TextField, Typography } from '@material-ui/core';
import ChipBowl from './ChipBowl';

type propTypes = {
    enqueueSnackbar?: any;
    maxTagLength?: any;
    register?: any;
    chipData?: any;
    setChipData?: any;
}

const ChipInput = (props: propTypes) => {

    const { chipData, setChipData } = props;

    const handleChipInput = (event) => {
        if (!event.key.match(/^[\w\-\s]+$/)) { //only allow alphanumeric
            event.preventDefault();
        }

        if (event.target.value.match(/Low\s?Poly/i)) {
            props.enqueueSnackbar("Everything on the site is low poly dude...", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                },
            });
            return;
        }

        if (event.key === 'Enter' && chipData.length < 8 && event.target.value.length >= 2) {
            setChipData([...chipData, { key: Math.random(), label: event.target.value }]);
            event.target.value = "";
        }
        else if (event.key === 'Enter' && chipData.length >= 8) {
            props.enqueueSnackbar("Too many tags! Try removing one", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                },
            });
        }

        if (event.target.value.length > props.maxTagLength) {
            event.preventDefault();
            event.target.value = event.target.value.slice(0, props.maxTagLength + 1);
        }
    }

    return (
        <>
            <TextField
                label="Add a search tag"
                fullWidth
                variant="outlined"
                onKeyPress={handleChipInput}
                className={`!mb-2`}
            />

            <ChipBowl chips={chipData} setChips={setChipData} />
        </>
    );
}

export default ChipInput;